import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Users, AlertTriangle, TrendingUp, Zap, Wallet } from "lucide-react";
import { api, getActiveSubdomain } from "@/lib/api";

export default function DealerDashboard() {
  const [data, setData] = useState(null);
  const [volume, setVolume] = useState({ volume: 0, count: 0 });
  const [wallet, setWallet] = useState({ balance: 0 });
  const { subdomain: paramSubdomain } = useParams();
  const activeSubdomain = getActiveSubdomain();
  const subdomain = activeSubdomain || paramSubdomain;
  const base = activeSubdomain ? "/dealer" : `/site/${subdomain}/dealer`;

  useEffect(() => {
    api.get("/dealer/dashboard").then(r => setData(r.data)).catch(() => {});
    api.get("/dealer/recharge-volume").then(r => setVolume(r.data)).catch(() => {});
    api.get("/dealer/wallet").then(r => setWallet(r.data)).catch(() => {});
  }, []);

  if (!data) return <div className="text-slate-400 pt-8 text-center">Loading dashboard…</div>;

  return (
    <div className="space-y-6">
      <h2 className="font-heading font-bold text-2xl text-brand-nav">Dashboard</h2>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <div className="bg-white rounded-xl border border-slate-200 p-5">
          <Users className="w-6 h-6 text-brand-primary mb-2" />
          <p className="font-heading font-bold text-3xl text-brand-nav">{data.my_customers}</p>
          <p className="text-xs text-slate-500 mt-1">My Customers</p>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 p-5">
          <AlertTriangle className="w-6 h-6 text-amber-500 mb-2" />
          <p className="font-heading font-bold text-3xl text-brand-nav">{data.expiring_30}</p>
          <p className="text-xs text-slate-500 mt-1">Expiring ≤30d</p>
        </div>
        <Link to={`${base}/wallet`} className="bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl p-5 text-white hover:shadow-lg transition-shadow">
          <Wallet className="w-6 h-6 mb-2 opacity-80" />
          <p className="font-heading font-bold text-3xl">₹{Math.round(wallet.balance).toLocaleString()}</p>
          <p className="text-xs opacity-80 mt-1">Wallet Balance</p>
        </Link>
        <div className="bg-white rounded-xl border border-slate-200 p-5">
          <TrendingUp className="w-6 h-6 text-brand-accent mb-2" />
          <p className="font-heading font-bold text-3xl text-brand-nav">₹{Math.round(volume.volume).toLocaleString()}</p>
          <p className="text-xs text-slate-500 mt-1">Total Volume</p>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 p-5">
          <Zap className="w-6 h-6 text-yellow-500 mb-2" />
          <p className="font-heading font-bold text-3xl text-brand-nav">{volume.count}</p>
          <p className="text-xs text-slate-500 mt-1">Recharges Done</p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <Link to={`${base}/customers`}
          className="bg-gradient-to-br from-brand-primary to-brand-accent text-white rounded-xl p-6 hover:shadow-lg transition-shadow">
          <p className="font-heading font-bold text-lg">Manage Customers</p>
          <p className="text-sm opacity-80 mt-1">Create, view and track customer subscriptions</p>
        </Link>
        <Link to={`${base}/recharge`}
          className="bg-white border-2 border-brand-primary rounded-xl p-6 hover:shadow-lg transition-shadow">
          <p className="font-heading font-bold text-lg text-brand-primary">Recharge for Customer</p>
          <p className="text-sm text-slate-500 mt-1">Initiate recharge on behalf of customers</p>
        </Link>
      </div>
    </div>
  );
}
